module.exports = __webpack_public_path__ + "static/media/service.0f75d8e7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/parent-agreement/views/main-record/images/service.svg
// module id = 1141
// module chunks = 0